<!--
 * @Author: likk 1126919170@qq.com
 * @Date: 2024-04-23 17:22:35
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-04-24 01:10:03
 * @FilePath: /m-ai.nongji360.com/src/components/Header.vue
 * @Description: 头部
-->
<template>
  <div class="header">
    <img class="logo" src="@/assets/images/spark/logo-text.png" />
    <div class="right-side">
			<div class="user" v-if="user">
				<div class="avatar" @click="quitShow = !quitShow">
					<img :src="user.avatar || require('@/assets/images/spark/avatar.png')"/>
				</div>
				<div class="quit" v-if="quitShow" @click="handleQuit()">
					<img class="icon" src="@/assets/images/spark/icon-exit.png"/>
					退出登录
				</div>
			</div>
			<span v-else class="btn" @click="handleLogin()">立即登录</span>
    </div>
  </div>
</template>

<script>
	export default {
		data(){
			return {
				quitShow:false,
			}
		},
		computed: {
			user(){
				return this.$store.state.userInfo
			}
		},
		methods:{
			/**
				* @description: 退出登录
				* @return {*}
			*/			
			handleQuit(){
				this.$store.dispatch("LoginOut");
			},
			/**
				* @description: 登录
				* @return {*}
			*/			
			handleLogin(){
				this.$router.push({path:"/login"})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 45px;
		padding: 0 10px;
		border-bottom: 1px solid #ECECEC;
		.logo{
			width: auto;
			height: 18px;
		}
		.right-side{
			.btn{
				display: block;
				width: 60px;
				height: 24px;
				line-height: 24px;
				text-align: center;
				background: linear-gradient(116deg, #8FDE21 0%, #639B14 100%);
				box-shadow: 0px 0px 3px rgba(0,0,0,0.12);
				border-radius: 4px;
				font-size: 12px;
				color: #ffffff;
			}
			.user{
				position: relative;
				.avatar{
					width: 30px;
					height: 30px;
					background: #F2F9E5;
					box-shadow: 0px 0px 3px rgba(0,0,0,0.12);
					border-radius: 6px;
					overflow: hidden;
					border: 1px solid #C6DEA0;
					display: flex;
					align-items: center;
					justify-content: center;
					img{
						max-width: 100%;
						max-height: 100%;
					}
				}
				.quit{
					display: flex;
					align-items: center;
					justify-content: center;
					width: 94px;
					height: 40px;
					background: #FFFFFF;
					box-shadow: 0px 0px 5px rgba(0,0,0,0.12);
					border-radius: 6px;
					font-size: 14px;
					color: #9A9A9A;
					position: absolute;
					right: 0;
					bottom: -50px;
					z-index: 1;
					.icon{
						width: 12px;
						height: 12px;
						margin-right: 2px;
					}
				}
			}
			
			
		}
	}
</style>